import React from "react";

function PlayStore() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="119.664"
      height="40"
      fill="none"
      viewBox="0 0 181 54"
    >
      <title>Get Our App On Play Store</title>

      <path
        fill="#000"
        d="M173.667 53.667H7c-3.667 0-6.667-3-6.667-6.667V7c0-3.667 3-6.667 6.667-6.667h166.667c3.666 0 6.666 3 6.666 6.667v40c0 3.667-3 6.667-6.666 6.667z"
      ></path>
      <path
        fill="#A6A6A6"
        d="M173.667.333H7C3.333.333.333 3.333.333 7v40c0 3.667 3 6.667 6.667 6.667h166.667c3.666 0 6.666-3 6.666-6.667V7c0-3.667-3-6.667-6.666-6.667zm0 1.067c3.088 0 5.6 2.513 5.6 5.6v40c0 3.088-2.512 5.6-5.6 5.6H7A5.607 5.607 0 011.4 47V7c0-3.087 2.513-5.6 5.6-5.6h166.667z"
      ></path>
      <path
        fill="#fff"
        d="M63.558 13.991c0 1.117-.33 2.007-.993 2.67-.753.79-1.734 1.184-2.94 1.184-1.154 0-2.136-.4-2.943-1.2-.81-.801-1.213-1.794-1.213-2.978 0-1.185.404-2.177 1.213-2.979.807-.8 1.789-1.2 2.944-1.2.572 0 1.12.111 1.642.335.52.224.938.521 1.25.894l-.702.703c-.53-.633-1.26-.949-2.19-.949-.843 0-1.57.296-2.185.888-.615.593-.922 1.362-.922 2.308 0 .946.307 1.714.922 2.307a3.042 3.042 0 002.184.888c.894 0 1.639-.297 2.235-.893.387-.388.61-.928.67-1.62h-2.904v-.962h3.876c.038.21.056.41.056.604"
      ></path>
      <path
        fill="#fff"
        d="M63.558 13.991h-.133c-.002 1.092-.32 1.94-.955 2.576l-.001.001v.001c-.73.762-1.666 1.141-2.843 1.143-1.124-.002-2.065-.385-2.85-1.162-.784-.779-1.172-1.73-1.173-2.883.001-1.155.389-2.105 1.172-2.883.786-.778 1.727-1.162 2.85-1.163.556 0 1.085.108 1.59.324.505.218.904.503 1.202.858l.102-.086-.094-.095-.704.704.095.094.102-.085c-.554-.664-1.332-.999-2.292-.997a3.175 3.175 0 00-2.278.926c-.641.616-.964 1.428-.962 2.403-.002.974.32 1.786.962 2.403a3.175 3.175 0 002.278.925c.922.002 1.709-.311 2.328-.932.414-.415.648-.989.71-1.703l.012-.145h-2.917v-.694h3.743v-.134l-.131.024c.036.202.053.394.053.58h.267c0-.202-.019-.41-.058-.627l-.02-.11h-4.12V14.482h3.038v-.134l-.133-.011c-.059.67-.273 1.176-.632 1.537-.573.571-1.276.853-2.14.855-.811-.001-1.5-.28-2.093-.85-.587-.57-.88-1.295-.88-2.212 0-.918.293-1.643.88-2.212.593-.57 1.282-.85 2.093-.85.901.002 1.582.3 2.088.901l.093.112.806-.807.087-.086-.08-.094c-.327-.39-.763-.7-1.3-.93a4.26 4.26 0 00-1.694-.347c-1.186 0-2.209.416-3.038 1.24-.833.823-1.253 1.858-1.252 3.073-.001 1.214.419 2.25 1.252 3.073.83.824 1.852 1.24 3.038 1.239 1.234 0 2.258-.41 3.035-1.225l-.096-.093.094.095c.69-.69 1.033-1.623 1.032-2.765h-.133zM69.704 10.65H66.06v2.536h3.286v.961H66.06v2.537h3.644v.983h-4.67v-8h4.67v.982z"
      ></path>
      <path
        fill="#fff"
        d="M69.704 10.65v-.134h-3.777v2.803h3.285v.695h-3.285v2.803h3.643v.716h-4.403V9.8h4.403v.85h.134v-.134.133h.133V9.534H64.9V17.8h4.937v-1.25h-3.643v-2.27h3.285v-1.227h-3.285v-2.27h3.643v-.133h-.133M74.038 17.667H73.01v-7.018h-2.235v-.982h5.498v.982h-2.234v7.018z"
      ></path>
      <path
        fill="#fff"
        d="M74.039 17.667v-.134h-.896v-7.017H70.91V9.8h5.23v.716h-2.234v7.15h.134v-.133.134h.133v-6.884h2.234v-1.25h-5.764v1.25h2.235V17.8h1.295v-.133h-.133M80.25 17.667v-8h1.028v8H80.25z"
      ></path>
      <path
        fill="#fff"
        d="M80.25 17.667h.134V9.8h.76v7.733h-.893v.134h.133-.133v.133h1.16V9.533h-1.294V17.8h.134v-.133zM85.838 17.667h-1.029v-7.018h-2.234v-.982h5.497v.982h-2.234v7.018z"
      ></path>
      <path
        fill="#fff"
        d="M85.838 17.667v-.134h-.895v-7.017h-2.235V9.8h5.231v.716h-2.234v7.15h.133v-.133.134h.133v-6.884h2.235v-1.25h-5.764v1.25h2.234V17.8h1.295v-.133h-.133M93.372 15.963c.593.6 1.317.899 2.174.899s1.582-.3 2.173-.899c.593-.6.89-1.366.89-2.296 0-.931-.297-1.697-.89-2.297-.591-.6-1.316-.899-2.173-.899s-1.582.3-2.174.9c-.59.599-.888 1.365-.888 2.296 0 .93.297 1.697.888 2.296zm5.107.67c-.786.809-1.764 1.212-2.933 1.212-1.17 0-2.148-.403-2.932-1.212-.788-.808-1.18-1.797-1.18-2.966 0-1.17.392-2.159 1.18-2.966.784-.81 1.762-1.214 2.932-1.214 1.162 0 2.138.407 2.928 1.219s1.184 1.799 1.184 2.96c0 1.17-.394 2.159-1.179 2.967z"
      ></path>
      <path
        fill="#fff"
        d="M93.372 15.963l-.094.094c.614.623 1.38.94 2.268.938.887.002 1.654-.315 2.268-.938.618-.624.929-1.431.928-2.39 0-.96-.31-1.767-.928-2.39-.613-.624-1.38-.94-2.268-.939-.888-.002-1.654.315-2.268.939-.617.623-.928 1.43-.927 2.39-.001.959.31 1.766.927 2.39l.094-.094.095-.094c-.565-.575-.848-1.3-.85-2.202.002-.903.285-1.627.85-2.203.571-.575 1.253-.858 2.079-.86.825.002 1.509.285 2.078.86.567.576.85 1.3.85 2.203 0 .903-.283 1.627-.85 2.202-.57.576-1.253.858-2.078.86-.826-.002-1.508-.284-2.079-.86l-.095.094zm5.107.67l-.095-.093c-.765.784-1.7 1.17-2.838 1.172-1.14-.002-2.074-.389-2.837-1.172l-.004-.004.004.004c-.763-.786-1.14-1.734-1.14-2.873 0-1.14.377-2.088 1.14-2.874.763-.783 1.698-1.17 2.837-1.172 1.131.001 2.064.39 2.833 1.178.765.79 1.144 1.736 1.145 2.868-.001 1.14-.379 2.087-1.14 2.873l.095.093.096.093c.808-.83 1.217-1.86 1.216-3.06.001-1.191-.41-2.22-1.221-3.053-.813-.837-1.83-1.26-3.024-1.259-1.2-.001-2.22.42-3.028 1.254-.81.83-1.218 1.86-1.216 3.059-.002 1.199.406 2.228 1.216 3.059l.003.004-.003-.005c.807.834 1.828 1.255 3.028 1.254 1.2 0 2.22-.42 3.03-1.253l-.097-.093M101.101 17.667v-8h1.251l3.888 6.223h.044l-.044-1.542V9.667h1.028v8h-1.073l-4.067-6.525h-.045l.045 1.542v4.983h-1.027z"
      ></path>
      <path
        fill="#fff"
        d="M101.101 17.667h.133V9.8h1.044l3.888 6.223h.255l-.048-1.677V9.8h.762v7.733h-.866l-4.067-6.525h-.256l.048 1.678v4.847h-.893v.134h.133-.133v.133h1.16v-5.118l-.044-1.544-.134.004v.133h.045v-.133l-.113.07 4.106 6.588H107.402V9.533H106.106v4.817l.045 1.544.133-.004v-.133h-.044v.133l.113-.07-3.928-6.287H100.967V17.8h.134v-.133zM142.915 40.333h2.488V23.665h-2.488v16.668zm22.409-10.664l-2.852 7.227h-.085l-2.96-7.227h-2.68l4.438 10.1-2.53 5.619h2.596l6.84-15.719h-2.767zm-14.109 8.771c-.816 0-1.952-.407-1.952-1.415 0-1.287 1.416-1.78 2.637-1.78 1.095 0 1.608.236 2.273.558-.193 1.543-1.522 2.637-2.958 2.637zm.3-9.135c-1.802 0-3.667.793-4.439 2.552l2.208.922c.472-.922 1.351-1.223 2.273-1.223 1.287 0 2.595.773 2.616 2.145v.171c-.45-.257-1.414-.643-2.594-.643-2.38 0-4.804 1.308-4.804 3.753 0 2.23 1.952 3.667 4.138 3.667 1.674 0 2.595-.75 3.175-1.63h.085v1.287h2.402v-6.39c0-2.96-2.208-4.611-5.06-4.611zm-15.376 2.393H132.6v-5.713h3.539c1.86 0 2.916 1.54 2.916 2.857 0 1.291-1.056 2.856-2.916 2.856zm-.064-8.033h-5.962v16.668h2.487v-6.315h3.475c2.757 0 5.468-1.996 5.468-5.176s-2.711-5.177-5.468-5.177zm-32.508 14.778c-1.719 0-3.158-1.439-3.158-3.415 0-1.998 1.439-3.459 3.158-3.459 1.697 0 3.028 1.461 3.028 3.459 0 1.976-1.331 3.415-3.028 3.415zm2.856-7.84h-.086c-.558-.666-1.632-1.268-2.985-1.268-2.836 0-5.435 2.492-5.435 5.693 0 3.179 2.599 5.65 5.435 5.65 1.353 0 2.427-.602 2.985-1.29h.086v.817c0 2.17-1.159 3.33-3.028 3.33-1.525 0-2.47-1.096-2.858-2.02l-2.169.902c.623 1.504 2.277 3.351 5.027 3.351 2.921 0 5.391-1.718 5.391-5.907V29.679h-2.363v.924zm4.082 9.73h2.491V23.665h-2.491v16.668zm6.165-5.499c-.065-2.19 1.697-3.308 2.964-3.308.989 0 1.826.494 2.105 1.204l-5.069 2.104zm7.733-1.89c-.472-1.268-1.912-3.609-4.855-3.609-2.921 0-5.349 2.299-5.349 5.671 0 3.18 2.406 5.671 5.628 5.671 2.6 0 4.104-1.59 4.726-2.513l-1.933-1.29c-.644.946-1.525 1.57-2.793 1.57-1.267 0-2.169-.581-2.749-1.72l7.582-3.135-.257-.645zm-60.411-1.869v2.406h5.756c-.171 1.353-.623 2.341-1.31 3.029-.837.838-2.148 1.761-4.446 1.761-3.545 0-6.315-2.857-6.315-6.4 0-3.545 2.77-6.402 6.315-6.402 1.912 0 3.307.752 4.339 1.718l1.697-1.696c-1.44-1.375-3.351-2.428-6.036-2.428-4.855 0-8.936 3.953-8.936 8.807 0 4.855 4.081 8.807 8.936 8.807 2.62 0 4.597-.859 6.143-2.47 1.59-1.59 2.084-3.824 2.084-5.628 0-.559-.043-1.074-.13-1.503h-8.097zm14.772 7.368c-1.72 0-3.201-1.418-3.201-3.437 0-2.04 1.482-3.437 3.2-3.437 1.719 0 3.201 1.397 3.201 3.437 0 2.02-1.482 3.437-3.2 3.437zm0-9.108c-3.137 0-5.693 2.385-5.693 5.671 0 3.265 2.556 5.671 5.693 5.671 3.136 0 5.692-2.406 5.692-5.67 0-3.287-2.556-5.672-5.692-5.672zm12.417 9.108c-1.718 0-3.2-1.418-3.2-3.437 0-2.04 1.482-3.437 3.2-3.437 1.719 0 3.2 1.397 3.2 3.437 0 2.02-1.481 3.437-3.2 3.437zm0-9.108c-3.136 0-5.692 2.385-5.692 5.671 0 3.265 2.556 5.671 5.692 5.671s5.693-2.406 5.693-5.67c0-3.287-2.557-5.672-5.693-5.672z"
      ></path>
      <path
        fill="url(#paint0_linear_1_3)"
        d="M14.346 43.52l-.099-.096c-.388-.41-.617-1.047-.617-1.873v.194-29.488-.006.202c0-.894.267-1.567.715-1.971l16.52 16.52-16.519 16.517zm-.716-31.271zm.006-.218v-.003.003zm0-.01v-.001.001z"
      ></path>
      <path
        fill="url(#paint1_linear_1_3)"
        d="M36.37 32.705l.126-.072 6.524-3.707c.622-.353 1.036-.782 1.243-1.235-.206.453-.62.883-1.243 1.236l-6.524 3.707-.126.07zm.002-.196l-5.508-5.508 5.507-5.507 6.649 3.777c.844.48 1.318 1.098 1.397 1.73v.002c-.079.63-.553 1.25-1.397 1.729l-6.648 3.777"
      ></path>
      <path
        fill="url(#paint2_linear_1_3)"
        d="M15.524 44.148c-.461 0-.864-.15-1.178-.433.314.283.718.433 1.18.433a2.514 2.514 0 00-.002 0zm0-.195c-.46 0-.864-.15-1.178-.433L30.864 27l5.508 5.508-19.354 10.997c-.535.303-1.043.447-1.494.447zm-1.182-.242a1.88 1.88 0 01-.086-.083l.086.084z"
      ></path>
      <path
        fill="url(#paint3_linear_1_3)"
        d="M30.865 27.001l-16.52-16.52a1.717 1.717 0 011.177-.432c.452 0 .96.144 1.496.448l19.353 10.997L30.865 27zm5.63-5.632L17.019 10.303c-.536-.305-1.044-.449-1.496-.449h-.006.008c.451 0 .958.144 1.494.448L36.496 21.37z"
      ></path>
      <path
        fill="#000"
        d="M15.647 44.145c.42-.024.883-.168 1.371-.445L36.37 32.706 17.018 43.7c-.487.278-.952.421-1.371.445zm-1.301-.43l-.004-.004a.03.03 0 01.004.004zm-.09-.087l-.009-.009.009.009z"
      ></path>
      <path
        fill="url(#paint4_linear_1_3)"
        d="M36.37 32.705l.126-.072-.126.072z"
      ></path>
      <path
        fill="url(#paint5_linear_1_3)"
        d="M15.525 44.148c-.461 0-.865-.15-1.179-.434v.001a.03.03 0 00-.004-.004l-.086-.083-.009-.01.1-.098c.313.283.716.434 1.178.433.45 0 .958-.144 1.493-.447l19.354-10.997.124.124-.126.072L17.018 43.7c-.488.277-.952.421-1.371.445a2.514 2.514 0 01-.122.003"
      ></path>
      <path
        fill="#000"
        d="M14.247 43.62c-.388-.411-.617-1.049-.617-1.874 0 .825.23 1.462.617 1.873"
      ></path>
      <path
        fill="url(#paint6_linear_1_3)"
        d="M14.247 43.619c-.388-.41-.617-1.048-.617-1.874v-.194c0 .825.23 1.463.617 1.873l.1.095-.1.1"
      ></path>
      <path fill="url(#paint7_linear_1_3)" d="M14.247 43.619l.1-.1-.1.1"></path>
      <path fill="#000" d="M44.263 27.69a1.656 1.656 0 010 0z"></path>
      <path
        fill="url(#paint8_linear_1_3)"
        d="M36.496 32.633l-.124-.124 6.648-3.777c.844-.48 1.318-1.099 1.397-1.729 0 .231-.051.463-.154.688-.207.453-.621.882-1.243 1.236l-6.524 3.706z"
      ></path>
      <path
        fill="#404040"
        d="M44.417 27.001c0-.698-.467-1.395-1.397-1.925l-6.524-3.706 6.524 3.706c.932.53 1.398 1.228 1.397 1.925z"
      ></path>
      <path
        fill="url(#paint9_linear_1_3)"
        d="M44.417 27c-.079-.631-.553-1.25-1.397-1.73l-6.649-3.776.124-.124 6.525 3.706c.93.53 1.397 1.227 1.397 1.924z"
      ></path>
      <path
        fill="#404040"
        d="M13.63 12.25v-.001.002zm.006-.216v-.003.003zm0-.006v-.007.007zm0-.008c.078-1.37.822-2.161 1.876-2.166a1.715 1.715 0 00-1.166.434v-.001l-.004.004c-.033.03-.064.06-.095.093-.35.37-.57.925-.61 1.636z"
      ></path>
      <path
        fill="url(#paint10_linear_1_3)"
        d="M13.63 12.453v-.195-.007-.002c0-.074.002-.145.006-.215v-.003-.003-.007-.001c.04-.711.261-1.266.611-1.636l.098.098c-.448.404-.715 1.077-.715 1.97zm.712-2.162l.004-.004-.004.004z"
      ></path>
      <path
        fill="url(#paint11_linear_1_3)"
        d="M36.371 21.494L17.018 10.497c-.536-.304-1.044-.448-1.496-.448-.461 0-.863.15-1.177.433l-.098-.098c.031-.032.062-.064.095-.093l.004-.004c.311-.28.71-.43 1.166-.433h.01c.452 0 .96.144 1.496.449l19.478 11.066-.125.125z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1_3"
          x1="29.4"
          x2="7.023"
          y1="11.946"
          y2="34.323"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF"></stop>
          <stop offset="0.007" stopColor="#00A1FF"></stop>
          <stop offset="0.26" stopColor="#00BEFF"></stop>
          <stop offset="0.512" stopColor="#00D2FF"></stop>
          <stop offset="0.76" stopColor="#00DFFF"></stop>
          <stop offset="1" stopColor="#00E3FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_3"
          x1="45.446"
          x2="13.183"
          y1="27.002"
          y2="27.002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000"></stop>
          <stop offset="0.409" stopColor="#FFBD00"></stop>
          <stop offset="0.775" stopColor="orange"></stop>
          <stop offset="1" stopColor="#FF9C00"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1_3"
          x1="33.436"
          x2="3.092"
          y1="30.061"
          y2="60.406"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44"></stop>
          <stop offset="1" stopColor="#C31162"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1_3"
          x1="10.063"
          x2="23.613"
          y1="0.568"
          y2="14.118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071"></stop>
          <stop offset="0.069" stopColor="#2DA771"></stop>
          <stop offset="0.476" stopColor="#15CF74"></stop>
          <stop offset="0.801" stopColor="#06E775"></stop>
          <stop offset="1" stopColor="#00F076"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1_3"
          x1="45.446"
          x2="13.184"
          y1="27.002"
          y2="27.002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCB300"></stop>
          <stop offset="0.409" stopColor="#CC9700"></stop>
          <stop offset="0.775" stopColor="#CC8400"></stop>
          <stop offset="1" stopColor="#CC7D00"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_1_3"
          x1="33.436"
          x2="3.092"
          y1="30.061"
          y2="60.406"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CC2E36"></stop>
          <stop offset="1" stopColor="#9C0E4E"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_1_3"
          x1="29.4"
          x2="7.023"
          y1="11.946"
          y2="34.323"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DE0"></stop>
          <stop offset="0.007" stopColor="#008DE0"></stop>
          <stop offset="0.26" stopColor="#00A7E0"></stop>
          <stop offset="0.512" stopColor="#00B8E0"></stop>
          <stop offset="0.76" stopColor="#00C4E0"></stop>
          <stop offset="1" stopColor="#00C7E0"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_1_3"
          x1="33.436"
          x2="3.092"
          y1="30.061"
          y2="60.406"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0333C"></stop>
          <stop offset="1" stopColor="#AB0F56"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_1_3"
          x1="45.446"
          x2="13.183"
          y1="27.002"
          y2="27.002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0C500"></stop>
          <stop offset="0.409" stopColor="#E0A600"></stop>
          <stop offset="0.775" stopColor="#E09100"></stop>
          <stop offset="1" stopColor="#E08900"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_1_3"
          x1="45.446"
          x2="13.183"
          y1="27.002"
          y2="27.002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE840"></stop>
          <stop offset="0.409" stopColor="#FFCE40"></stop>
          <stop offset="0.775" stopColor="#FFBC40"></stop>
          <stop offset="1" stopColor="#FFB540"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_1_3"
          x1="29.4"
          x2="7.023"
          y1="11.946"
          y2="34.323"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40B8FF"></stop>
          <stop offset="0.007" stopColor="#40B9FF"></stop>
          <stop offset="0.26" stopColor="#40CEFF"></stop>
          <stop offset="0.512" stopColor="#40DDFF"></stop>
          <stop offset="0.76" stopColor="#40E7FF"></stop>
          <stop offset="1" stopColor="#40EAFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_1_3"
          x1="10.063"
          x2="23.613"
          y1="0.568"
          y2="14.118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#65B895"></stop>
          <stop offset="0.069" stopColor="#62BD95"></stop>
          <stop offset="0.476" stopColor="#50DB97"></stop>
          <stop offset="0.801" stopColor="#44ED98"></stop>
          <stop offset="1" stopColor="#40F498"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PlayStore;
